import { render, staticRenderFns } from "./InventarioItens.vue?vue&type=template&id=2e2c5f82&"
import script from "./InventarioItens.vue?vue&type=script&lang=js&"
export * from "./InventarioItens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports